// Daftar tab form Cataloguer (FORM02). `configKey` = key tab di FORM02_BASE.json.
// Satu sumber untuk dua pemakai, supaya label di modal validasi selalu sama dengan label tab di layar:
// - New_CataloguerForm.vue -> daftar tab yang dirender
// - New_McrFooter.vue      -> label tab di modal "Please complete the following tabs" (validateSingleMcrItem)
export const CATALOGUER_TAB_LIST = [
	{ value: '6', label: 'User Request', configKey: 'user_request' },
	{ value: '0', label: 'Basic Data & Characteristic', configKey: 'BASIC_DATA' },
	{ value: '15', label: 'PO Text', configKey: 'po_text' },
	{ value: '16', label: 'Attachment Document & Keyword', configKey: 'attachment_document_keyword' },
	{ value: '2', label: 'Manufacture & Equipment', configKey: 'manufacture_equipment' },
	{ value: '17', label: 'Plant & Storage Location', configKey: 'plant_storage_location' },
	{ value: '5', label: 'Accounting', configKey: 'accounting' },
	{ value: '1', label: 'MRP', configKey: 'mrp' },
	{ value: '18', label: 'Purchasing & Quality Management', configKey: 'purchasing_quality_management' },
	{ value: '10', label: 'Sales, Gen. Plant & Sales', configKey: 'sales_general_sales' },
	{ value: '12', label: 'Warehouse Management', configKey: 'warehouse_management' },
	{ value: '19', label: 'INALUM Data & Inspection Text', configKey: 'data_satu_inspection_text' },
];
